










import Vue from 'vue';
import {Component} from "vue-property-decorator";
import AsiPageTitle from "@/components/common/AsiPageTitle.vue";
import {Icon} from "@/helpers/icons";
import OrderList from "@/components/order/OrderList.vue";
import OrderCreateDialog from "@/components/order/OrderCreateDialog.vue";
import {Permissions} from "@/helpers/constants";
import CompanySimple from "@/models/company/CompanySimple";

@Component({
	components: {OrderCreateDialog, OrderList, AsiPageTitle}
})
export default class Orders extends Vue {

	private icons = Icon;
	private createDialogOpen: boolean = false;

	private get isMasterData(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightMasterData);
	}

	private get isCustomer(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightCustomer);
	}

	private get company(): CompanySimple | null {
		return this.isCustomer ? this.$store.state.user.loggedInUserCompany : null;
	}

}
